import React, { useState } from "react";
import aboutGIF from "../assets/img/about-epic-x.gif";
import vission from "../assets/img/Vision-mission.svg";
import artificial from "../assets/img/artificial.png"
import mobileApp from "../assets/img/mobile-app.png"
import AppDevelopment from "../assets/img/App-development.png"
import microsoftDevelopment from "../assets/img/microsoft-development.png"
import UXUI from "../assets/img/UX-UI.png"
import Cloudconsulting from "../assets/img/Cloud-consulting.png"
import Processautomation from "../assets/img/Process-automation.png"
import manageservice from "../assets/img/manage-service.jpg"
import AIFeature from"../assets/img/AI-feature.png"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'; // Import Swiper styles
import { Navigation, Pagination } from 'swiper/modules';
import user1 from "../assets/img/test-user-1.png"
import tnxt from "../assets/img/t-nxt.png"
import user2 from "../assets/img/test-user-2.png"
import newsletterAI from "../assets/img/newsletter-ai.png"
import { Link } from "react-router-dom";

const MainContent = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "What services does your software company offer?",
      answer:
        "A: We specialize in custom software development, web and mobile app development, UI/UX design, cloud solutions, and IT consulting.",
    },
    {
      question: "How do you ensure the security of your software solutions?",
      answer:
        "A: We follow industry best practices, including encryption, secure coding standards, regular security audits, and compliance with relevant data protection regulations.",
    },
    {
      question: "Can you customize software according to our business needs?",
      answer:
        "A: Yes, we specialize in tailor-made software solutions designed to fit your unique business requirements and enhance operational efficiency.",
    },
    {
      question: "What technologies do you use in software development?",
      answer:
        "A: Our tech stack includes JavaScript (React, Angular, Node.js), Python, Java, .NET, PHP, cloud computing, and AI/ML technologies.",
    },
    {
      question: "What is your software development process?",
      answer:
        "A: Our process includes requirement gathering, design and prototyping, development, testing, deployment, and ongoing maintenance and support.",
    },
  ];
  const featuresData = [
    {
      icon: "fa-solid fa-robot fa-3x",
      title: "AI-Powered E-Commerce Development",
      description:
        "We specialize in AI-powered eCommerce website design and development, ensuring high-performance, scalable, and conversion-driven online stores.",
      link: "/ai-driven/E-Commerce",
    },
    {
      icon: "fa-solid fa-money-check fa-3x",
      title: "Secure AI Payment Integration",
      description:
        "We specialize in AI-driven secure payment integration for eCommerce websites, ensuring fast, fraud-proof, and seamless transactions.",
      link: "/ai-driven/ai-payment",
    },
    {
      icon: "fa fa-bullseye fa-3x",
      title: "Scalable AI API Solutions",
      description:
        "We provide AI-driven API integration services to connect, automate, and optimize your business operations.",
      link: "/ai-driven/ai-api-integration",
    },
    {
      icon: "fa-solid fa-headset fa-3x",
      title: "Post-Launch Support for Web",
      description:
        "We provide end-to-end post-launch support to keep your eCommerce store, web application, or API-driven platform running at peak performance.",
      link: "/ai-driven/post-launch-support",
    },
  ];

  const servicesData = [
    {
      img: artificial,
      title: "Artificial Intelligence",
      description:
        "Leverage the power of Artificial Intelligence (AI) solutions to automate workflows, improve decision-making, and drive business growth.",
      link: "/services",
    },
    {
      img: mobileApp,
      title: "Mobile App Development",
      description:
        "Expand your digital presence with custom mobile app development services for Android, iOS, and cross-platform solutions.",
      link: "/services",
    },
    {
      img: AppDevelopment,
      title: "Application Development Services",
      description:
        "Enhance operational efficiency with our custom application development services, designed to meet your unique business needs.",
      link: "/services",
    },
    {
      img: microsoftDevelopment,
      title: "Microsoft Application Development",
      description:
        "Optimize business productivity with Microsoft Application Development, leveraging powerful tools like Microsoft...",
      link: "/services",
    },
    {
      img: UXUI,
      title: "Website Design & UI/UX Services",
      description:
        "Boost your online presence with SEO-friendly, high-converting website design and UI/UX services. We specialize in custom website development using WordPress, Shopify, Magento, Drupal, and other CMS platforms, along with React...",
      link: "/services",
    },
    {
      img: Cloudconsulting,
      title: "Cloud Consulting & Migration",
      description:
        "Adopt a cloud-first strategy with our expert Cloud Consulting and Migration services. We help businesses seamlessly migrate, manage, and optimize workloads on AWS, Azure, Google Cloud, Hostinger, DigitalOcean, and other leading cloud platforms.",
      link: "/services",
    },
    {
      img: Processautomation,
      title: "DevOps & Process Automation",
      description:
        "Accelerate software development and IT operations with our DevOps & Process Automation solutions. We streamline CI/CD pipelines, infrastructure automation, and cloud deployment strategies for businesses looking to improve.",
      link: "/services",
    },
    {
      img: manageservice,
      title: "Managed IT Services",
      description:
        "Ensure 24/7 IT support, security, and infrastructure management with our comprehensive Managed IT Services. We provide proactive monitoring, cybersecurity solutions, cloud management, and IT consulting, ensuring uninterrupted business operations.",
      link: "/services",
    },
  ];

  const testimonialsData = [
    {
      img: user1,
      quote:
        'I wanted to take a moment to express our profound appreciation for the exceptional work you have done in delivering the Magento commerce solution for our business. Your dedication, expertise, and commitment to excellence have truly made a significant impact on our operations and success.',
      name: 'Coswan Silvers - KARTHIK',
      role: 'Ceo & Founder',
    },
    {
      img: tnxt,
      quote:
        'Your responsive and agile approach to problem-solving, the timeliness of project milestones, and your continuous support in addressing any issues have been invaluable. Your team’s attention to detail, clear communication, and willingness to go the extra mile have truly set you apart. We recognize that a successful Mobile App solution is the result of a collaborative effort, and your contributions have been a vital part of our journey. You’ve not only provided us with a powerful React Native platform but also a sense of confidence in our operations.',
      name: 'Lavanya - T-Nxt',
      role: 'Project Manager',
    },
    {
      img: user2,
      quote:
        'From the initial project planning to the final implementation, your team’s professionalism and technical proficiency have been outstanding. You’ve not only met but exceeded our expectations in every aspect of this project. The seamless integration of React Web Application platform along with payment gateway has enhanced our online presence, improved user experience, and driven impressive results. Your ability to customize and optimize the solution to meet our unique business needs has been remarkable.',
      name: 'Arun Paul',
      role: 'MalayaWood',
    },
  ];
  return (
    <>
      {/* <!-- About Start --> */}
      <div className="bg-light about">
        <div className="container-fluid pb-5">
          <div className="row">
            <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
              <div className="about-item-content rounded p-5 h-100">
                <h2 className="text-primary section-heading">
                  About Our Company
                </h2>
                <p className="text-black">
                  Founded in 2023, Epic-X is a technology-driven company based
                  in Coimbatore, Tamil Nadu, specializing in AI-powered
                  applications that enhance automation, optimize workflows, and
                  drive intelligent decision-making.
                </p>
                <p className="text-black">
                  We specialize in mobile & web app development, offering
                  scalable solutions, cloud integration, and digital
                  transformation for seamless experiences.
                </p>
                <p className="text-black">
                  We offer end-to-end e-commerce development, enhancing
                  engagement, boosting sales, and driving business growth.
                </p>
                <h2 className="text-primary section-heading">Who we are</h2>
                <p className="text-black">
                  We are a team of performance-driven entrepreneurs with a
                  passionate commitment to building innovative products and
                  providing state-of-the-art digital solutions that empower
                  businesses to thrive in the online marketplace.
                </p>
              </div>
            </div>
            <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.2s">
              <div className="rounded p-5 h-100">
                <div className="row g-4 justify-content-center">
                  <div className="col-12">
                    <div className="rounded bg-light">
                      <img
                        src={aboutGIF}
                        className="img-fluid rounded w-100"
                        alt="About-epic-X Process"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}

      {/* <!---Vision and Mission start--> */}
      <div className="section-padding bg-blue-light">
        <div className="container">
          <div className="who-we-area-box">
            <div className="row">
              <div className="col-lg-5">
                <img
                  src={vission}
                  className="img-fluid rounded w-100"
                  alt="About-epic-X Process"
                />
              </div>
              <div className="col-lg-7 info">
                <div className="row section-padding">
                  <div className="col-lg-12 col-md-12 item">
                    <div className="aligns">
                      <h4 className="pl-0 mr-2 section-heading fs-35 text-blue font-semibold">
                        Our Mission
                      </h4>
                      <span className="mb-2 line"></span>
                    </div>
                    <p className="text-black">
                      To revolutionize technology interactions through
                      AI-powered products that offer autonomous, effortless
                      experiences. We aim to enhance lives with intelligent,
                      user-centric solutions and redefine customer satisfaction
                      with exceptional service.
                    </p>
                  </div>
                  <div className="col-lg-12 col-md-12 item">
                    <div className="aligns">
                      <h4 className="pl-0 mr-2 section-heading fs-35 text-blue font-semibold">
                        Our Vision
                      </h4>
                      <span className="mb-2 line"></span>
                    </div>
                    <p className="text-black">
                      To make AI an indispensable part of daily life by
                      developing advanced technologies focused on autonomy,
                      intelligence, and user experience, creating products that
                      anticipate and enrich users' lives.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!---Vision and Mission start END--> */}

      {/* <!-- Feature Start --> */}
      <div className="container-fluid feature bg-light py-5">
        <div className="container py-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h4 className="text-primary">Our Features</h4>
            <h1 className="display-4 mb-4">
              Empower Your Business with Scalable SaaS Solutions
            </h1>
            <p className="mb-0 font-size-p">
              Epic-X specializes in custom e-commerce development, offering
              secure payment gateways, seamless API integration, and 24/7
              post-launch support to enhance online businesses.
            </p>
          </div>
          <div className="row g-4">
            <div
              className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="p-4 pt-0">
                <div className="feature-icon p-4 mb-4">
                  <i className="fa-solid fa-store fa-3x"></i>
                </div>
                <h4 className="mb-4">AI B2C E-Commerce Solutions</h4>
                <p className="mb-4 font-size-p">
                  Epic-X offers AI-powered B2C eCommerce solutions for seamless
                  ordering, management, and delivery with real-time insights and
                  smart integrations.
                </p>
                <Link
                  className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                  to="/Features/B2C"                >
                  Read More
                </Link>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
              data-wow-delay="0.4s"
            >
              <div className="p-4 pt-0">
                <div className="feature-icon p-4 mb-4">
                  <i className="fa-solid fa-mobile-screen-button fa-3x"></i>
                </div>
                <h4 className="mb-4">Smart B2B Procurement App</h4>
                <p className="mb-4 font-size-p">
                  Our B2B app streamlines inventory and procurement, ensuring
                  seamless, efficient, and error-free ordering.
                </p>
                <Link
                  className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                  to="/Features/B2B"                >
                  Read More
                </Link>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
              data-wow-delay="0.6s"
            >
              <div className="p-4 pt-0">
                <div className="feature-icon p-4 mb-4">
                  <i className="fa-regular fa-message fa-3x"></i>
                </div>
                <h4 className="mb-4">Shopify Chat & AI Assistance</h4>
                <p className="mb-4 font-size-p">
                  Elevate your eCommerce experience with our Shopify app,
                  designed to provide real-time customer interaction, AI-driven
                  automation, and chatbot support.
                </p>
                <Link
                  className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                  to="/Features/Chat"                >
                  Read More
                </Link>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
              data-wow-delay="0.8s"
            >
              <div className="p-4 pt-0">
                <div className="feature-icon p-4 mb-4">
                  <i className="fa-brands fa-shopify fa-3x"></i>
                </div>
                <h4 className="mb-4">AI Shopify Pop-Ups</h4>
                <p className="mb-4 font-size-p">
                  Take your Shopify store to the next level with intelligent
                  pop-ups designed to capture leads, reduce cart abandonment,
                  and boost sales.
                </p>
                <Link
                  className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                  to="/Features/Popup"                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Feature End --> */}

      {/* <!-- AI Features Start --> */}
      <div className="container-fluid ai-feature bg-blue py-5">
        <div className="container py-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-4 fs-46 mb-4 text-white">
              Empower Your Business with AI-Driven Solutions for Growth.
            </h1>
            <p className="mb-0 text-white">
              Epic-X specializes in custom e-commerce development, offering
              secure payment gateways, seamless API integration, and 24/7
              post-launch support to enhance online businesses.
            </p>
          </div>
          <div className="row g-4">
            {featuresData.map((feature, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay={`${0.2 + index * 0.2}s`}
              >
                <div className="ai-feature-item p-4 pt-0">
                  <div className="ai-feature-icon p-4 mb-4">
                    <i className={feature.icon}></i>
                  </div>
                  <h4 className="mb-4">{feature.title}</h4>
                  <p className="mb-4 font-size-p">{feature.description}</p>
                  <Link
                    className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                    to={feature.link}
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <!-- AI Features END --> */}

      {/* <!-- Service START --> */}
      <div className="container-fluid service py-5">
        <div className="container py-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h4 className="text-primary">Our Services</h4>
            <h1 className="display-4 mb-4">
              We Provide the Best Services to Transform Your Business
            </h1>
            <p className="mb-0 font-size-p">
              Empower your business with cutting-edge Artificial Intelligence
              solutions, intuitive Mobile App Development, and robust
              Application Development tailored to your needs. Enhance
              productivity with Microsoft Application Development, stunning
              Website Design & UI/UX Services, and seamless Cloud Consulting for
              scalable growth.
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            {servicesData.map((service, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay={`${0.2 + index * 0.2}s`}
              >
                <div className="service-item">
                  <div className="service-img">
                    <img
                      src={service.img}
                      className="img-fluid rounded-top w-100"
                      alt={service.title}
                    />
                  </div>
                  <div className="service-content p-4">
                    <div className="service-content-inner">
                      <a href="#" className="d-inline-block h4 mb-4">
                        {service.title}
                      </a>
                      <p className="mb-4 font-size-p">{service.description}</p>
                      <Link
                        className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                        to={service.link}
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div
              className="col-12 text-center wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <Link
                className="btn-epic-x btn-primary rounded-pill py-2 px-4"
                to="/services"
              >
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Service End --> */}

      {/* <!-- FAQs Start --> */}
      <div className="container-fluid faq-section bg-light py-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
              <div className="h-100">
                <div className="mb-5">
                  <h4 className="text-primary">Frequently Asked Questions</h4>
                  <h1 className="display-4 mb-0">Common Queries and Answers</h1>
                </div>
                <div className="accordion" id="accordionExample">
                  {faqData.map((faq, index) => (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className={`accordion-button ${
                            activeIndex === index ? "" : "collapsed"
                          }`}
                          type="button"
                          onClick={() => toggleAccordion(index)}
                          aria-expanded={activeIndex === index}
                          aria-controls={`collapse${index}`}
                        >
                          {faq.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${
                          activeIndex === index ? "show" : ""
                        }`}
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">{faq.answer}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.4s">
              <img
                src={AIFeature}
                className="img-fluid w-100"
                alt="AI-FAQ"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- FAQs END --> */}

      {/* <!-- Testimonial Start -->
      <!-- ======= Testimonials Section ======= --> */}
      <section id="testimonials" className="testimonials">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Testimonials</h2>
          <p className="text-center section-heading text-blue">What they are saying about us</p>
        </header>
        <div className="testimonial mySwiper">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
            pagination={{ clickable: true, el: '.swiper-pagination' }}
          >
            {testimonialsData.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="slide swiper-slide">
                  <img src={testimonial.img} alt={`testimonials-${index + 1}`} className="image" />
                  <p>{testimonial.quote}</p>
                  <i className="bx bxs-quote-alt-left quote-icon"></i>
                  <div className="details">
                    <span className="name">{testimonial.name}</span>
                    <span className="job">{testimonial.role}</span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-button-next nav-btn"></div>
          <div className="swiper-button-prev nav-btn"></div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
    {/* <!-- End Testimonials Section -->
    <!-- Testimonial End --> */}

    {/* <!--Newsletter START --> */}
    <div className="container-fluid bg-primary newsletter py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div
            className="col-md-5 ps-lg-0 pt-5 pt-md-0 text-start wow fadeIn"
            data-wow-delay="0.3s"
          >
            <img
              className="img-fluid ai-news-click"
              src={newsletterAI}
              alt="Ai-Newsletter"
            />
          </div>
          <div
            className="col-md-7 py-5 newsletter-text wow fadeIn"
            data-wow-delay="0.5s"
          >
            <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Newsletter</div>
            <h1 className="text-white mb-4">Let's subscribe the newsletter</h1>
            <div className="position-relative w-100 mt-3 mb-2">
              <input
                className="form-control border-0 rounded-pill w-100 ps-4 pe-5"
                type="text"
                placeholder="Enter Your Email"
                style={{ height: '48px' }}
              />
              <button
                type="button"
                className="btn-epic-x shadow-none position-absolute top-0 end-0 mt-1 me-2"
              >
                <i className="fa fa-paper-plane text-primary fs-4"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!--Newsletter End --> */}
    </>
  );
};

export default MainContent;
